// IMPORT CSS
import '../../sass/pages/_chapter.scss'

// IMPORT SWIPERS
import { loadRecipeSwiper, loadChapterSwiper } from "../components/customSwipers";

// IMPORT LIBRARIES
import "lazysizes";

// IMPORT CUSTOM LIBRARIES
import Modal from "../components/modal";
import TriggerAnimation from '../components/triggerAnimation';
import SplitText from '../components/splitText';
import Recipes from '../components/recipes';

let chapterList = ['Costa', 'Sierra', 'Oriente'];

(function page() {
    let loader = document.querySelector('.loader')
    let domElements = setInitialState()
    loadSwipers()
    new Modal('#ModalVideo', { activators: '.cp-video-preview', iframeWrapper: 'iframeWrapper' })

    if (loader) return loader.addEventListener('onHide', () => loadAnimation(domElements))
    loadAnimation(domElements)
})()

// ESTABLECE Y CARGA LAS ANIMACIONES
function setInitialState() {
    let chapterTitle = new SplitText('.cp-page-chapter-meals__title', {
        auto: false
    })
    let chapterSubtitle = new SplitText('.cp-chapter-info__subtitle', {
        auto: false
    })

    let titles = new SplitText('.cp-chapter-list__title, .cp-chapter-preview__title')

    // CHAPTER INFO SECTION
    let chapterFeaturedVideo = new TriggerAnimation('.cp-chapter-info__featured, .cp-chapter-info__video', {
        mobile: {
            to: { delay: 0.5, stagger: 0.2, scrollTrigger: { trigger: '.cp-page-chapter-meals__title' } }
        },
        desktop: {
            to: { delay: 0.8, stagger: 0.3, scrollTrigger: { trigger: '.cp-page-chapter-meals__title' } }
        }
    })
    let chapterDesc = new TriggerAnimation('.cp-chapter-info__desc', {
        mobile: {
            to: { delay: 0.8, onComplete: () => { chapterSubtitle.triggerAnimation() } }
        },
        desktop: {
            to: { delay: 0, onComplete: () => { chapterSubtitle.triggerAnimation() } }
        }
    })
    let recipeCard = new TriggerAnimation('.cp-card-recipe', {
        mobile: {
            from: { translateX: 30, opacity: 0 },
            to: { translateX: 0, stagger: 0.2, scrollTrigger: { trigger: '#recipeSwiper', start: 'top bottom-=150px' } }
        }
    })

    // CHAPTER LIST SECTION
    let videos = new TriggerAnimation('.cp-chapter-preview .cp-video-preview', {
        mobile: {
            to: { stagger: 0.5, scrollTrigger: { trigger: '#chapterSwiper' } }
        }
    })
    let descAndButton = new TriggerAnimation('.cp-chapter-preview__desc, .cp-chapter-preview__btn')

    // SWIPER ELEMENTS
    let swiperElements = new TriggerAnimation('.swiper-pagination', {
        mobile: {
            from: { opacity: 0 },
            to: { duration: 0.5 }
        }
    })

    return [
        chapterTitle, titles, chapterFeaturedVideo, chapterDesc,
        recipeCard, videos, descAndButton, swiperElements
    ]
}

function loadAnimation(elements: Array<SplitText | TriggerAnimation>) {
    elements.forEach((element: any) => element.triggerAnimation())
}

// CARGA LOS SWIPER
async function loadSwipers() {
    let recipeSwiper = loadRecipeSwiper()
    let currentChapter = chapterList.find(chapterName => location.href.includes(chapterName.toLocaleLowerCase()))

    // Carga las recetas y la funcionalidad del buscador
    new Recipes('#recipeSwiper .swiper-wrapper', {
        filters: {
            category: currentChapter
        },
        on: {
            update: () => recipeSwiper?.update()
        }
    })

    loadChapterSwiper()
}